import { render, staticRenderFns } from "./RotatedTh.vue?vue&type=template&id=4c5547e2&scoped=true"
import script from "./RotatedTh.vue?vue&type=script&lang=js"
export * from "./RotatedTh.vue?vue&type=script&lang=js"
import style0 from "./RotatedTh.vue?vue&type=style&index=0&id=4c5547e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5547e2",
  null
  
)

export default component.exports